import {createVuetify, IconProps, IconSet} from "vuetify"
import {md3} from "vuetify/blueprints"
import * as components from "vuetify/components"
import * as directives from "vuetify/directives"

import austria from "@/components/flags/atFlag.vue"
import usa from "@/components/flags/usFlag.vue"

import {aliases, mdi} from "vuetify/iconsets/mdi"
import {de} from "vuetify/locale"
import {KPMGDDSTheme} from "@/styles/dds-vuetify-theme"
import '@/styles/dds-main.scss'
import KSidePanel from '@/components/dds/KSidePanel.vue'
import KDatePicker from '@/components/dds/KDatePicker.vue'
import '@mdi/font/css/materialdesignicons.css'
import TopNavbar from '@/components/dds/TopNavbar.vue'
import SideNavbar from '@/components/dds/SideNavbar.vue'
import {h} from "vue";

const flagsSvgNameToComponent: any = {
    austria,
    usa,
};

const flags: IconSet = {
    component: (props: IconProps) =>
        h(props.tag, [h(flagsSvgNameToComponent[props.icon as string], { class: 'v-icon__svg' })]),
}

const UIDCheckTheme = {
    ...KPMGDDSTheme,
    colors: {
        ...KPMGDDSTheme.colors,
        "trtTealGreen": "#00a3a1"
    }
}

export default createVuetify({
    blueprint: md3,
    components: {
        ...components,
        KDatePicker,
        KSidePanel,
        TopNavbar,
        SideNavbar,
    },
    defaults: {
        VBtn: {
            color: 'primary',
            variant: 'outlined',
            rounded: false,
        },
    },
    directives,
    icons: {
        defaultSet: 'mdi',
        aliases,
        sets: {
            mdi,
            flags
        },
    },
    locale: {
        locale: 'de',
        messages: {de},
    },
    theme: {
        cspNonce: 'dWgZa6gLkG52s',
        defaultTheme: 'UIDCheckTheme',
        themes: {
            UIDCheckTheme,
        }
    }
})
